export default __webpack_public_path__ + "static/media/reports.02a67e0a.svg";